import { useTranslation } from 'react-i18next'
import React from 'react'
import moment from 'moment'

import { MONTH_OPTIONS } from '../../../utils/constants/date'
import DropdownLink from '../../navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../structure/FlexGrid'
import Icon from '../../shapes/Icon'
import IconText from '../../presentation/IconText'
import Input from '../Input'
import Link from '../../actions/Link'
import Separator from '../../helpers/Separator'
import SeparatorWrapper from '../../helpers/SeparatorWrapper'
import { COLORS } from '@btime/constants'

const DayPickerHeader = ({ handleMonthChange, setMonth, month }) => {
  const { t } = useTranslation()
  return (
    <div>
      <FlexGrid align="center" justify="space-between">
        <Link onClick={handleMonthChange(-1, month)}>
          <SeparatorWrapper weight={2}>
            <Icon name="BsChevronLeft" size="1rem" />
          </SeparatorWrapper>
        </Link>

        <FlexCol flex={1}>
          <FlexGrid gutter={0.4}>
            <DropdownLink
              onChange={v =>
                setMonth(
                  moment(month)
                    .month(v - 1)
                    .toDate()
                )
              }
              options={MONTH_OPTIONS}
              t={v => t('month.' + v, v)}
              actionContent={
                <IconText
                  iconName="BsFillCaretDownFill"
                  bold
                  color={COLORS.dark3}
                  label={moment(month).format('MMM')}
                  iconSize=".8rem"
                  separatorWeight={0.2}
                />
              }
            />

            <FlexCol width={'4rem'}>
              <Input
                limit={4}
                xsmall
                onStopTyping={v => setMonth(moment(month).year(v).toDate())}
                value={moment(month).year()}
              />
            </FlexCol>
          </FlexGrid>
        </FlexCol>

        <Link onClick={handleMonthChange(1, month)}>
          <SeparatorWrapper weight={2}>
            <Icon name="BsChevronRight" size="1rem" />
          </SeparatorWrapper>
        </Link>
      </FlexGrid>
      <Separator weight={3} />
    </div>
  )
}

export default DayPickerHeader
